import React from "react";
import ReactDOM from "react-dom/client";
import "leaflet/dist/leaflet.css";
import "./index.css";
import App from "./App";

// Set HTML lang attribute to French for this French platform
// This ensures browser autocomplete and accessibility tools use French
document.documentElement.lang = 'fr';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
